var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * CZNA-456 — hook for `POST /czna-authorities/module-settings/form-configs`.
 *
 * This is the only way a new template can come into being: `PUT /{key}` is
 * documented not to create rows ("404 — PUT does not create rows, reconcile
 * seeds them"), so before this endpoint a new form needed a release.
 *
 * Error surface, and why it is this shape — plan WP-FE CP-1 requires the two
 * expected failures to land on the field that caused them rather than in a
 * generic banner:
 * - **409** → the `templateId` is taken within this type. Belongs on the id field.
 * - **400 + `FormConfigValidationResult` body** → the payload was rejected by
 *   the catalog validator (same wire shape as PUT and the dry-run, so the
 *   existing renderer applies). Nothing was persisted.
 * - **400 without that body** → a malformed request (bad id pattern, unknown
 *   recordType, both/neither of copyFrom+value). Also an id-field problem in
 *   practice, since the dialog constrains everything else.
 * - **404** → `copyFrom` names a key that no longer exists, e.g. the source
 *   template was deleted in another tab.
 *
 * MEMORY rule: `useOkapiKy()` is captured in the mutation closure, never
 * listed in a hook dep array.
 */
import { useOkapiKy } from '@folio/stripes/core';
import { useMutation, useQueryClient } from 'react-query';
import { API_PATHS } from '../types/apiPaths';
import { formConfigTemplatesQueryKey } from './useFormConfigTemplates';
import { moduleSettingInvalidationKeys } from './useModuleSetting';
import { isTimeoutError } from '../utils/errorKind';
var CreateFormConfigError = /** @class */ (function (_super) {
    __extends(CreateFormConfigError, _super);
    function CreateFormConfigError(status, body, cause) {
        var _this = _super.call(this, "useCreateFormConfig failed: HTTP ".concat(status !== null && status !== void 0 ? status : 'unknown')) || this;
        _this.name = 'CreateFormConfigError';
        _this.status = status;
        _this.timedOut = isTimeoutError(cause);
        _this.body = body;
        if (cause !== undefined) {
            _this.cause = cause;
        }
        return _this;
    }
    return CreateFormConfigError;
}(Error));
var useCreateFormConfig = function () {
    var _a, _b, _c, _d, _e, _f;
    // Closure-capture only. MEMORY: ky is unstable — never in deps.
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var mutation = useMutation(function (input) { return __awaiter(void 0, void 0, void 0, function () {
        var err_1, status_1, body, _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 7]);
                    return [4 /*yield*/, ky
                            .post(API_PATHS.CZNA_MODULE_SETTINGS_FORM_CONFIGS, { json: input })
                            .json()];
                case 1: return [2 /*return*/, _c.sent()];
                case 2:
                    err_1 = _c.sent();
                    status_1 = (_b = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _b === void 0 ? void 0 : _b.status;
                    body = null;
                    if (!(status_1 === 400 && err_1 && typeof err_1 === 'object' && 'response' in err_1)) return [3 /*break*/, 6];
                    _c.label = 3;
                case 3:
                    _c.trys.push([3, 5, , 6]);
                    return [4 /*yield*/, err_1.response
                            .clone()
                            .json()];
                case 4:
                    body = (_c.sent());
                    return [3 /*break*/, 6];
                case 5:
                    _a = _c.sent();
                    // A 400 that is not a validator rejection (bad id, unknown type)
                    // has no structured body — the status alone carries the meaning.
                    body = null;
                    return [3 /*break*/, 6];
                case 6: throw new CreateFormConfigError(status_1, body, err_1);
                case 7: return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function (created, input) {
            // Both list slots: the per-type one the settings page reads and the
            // unfiltered one the create dialog reads. Invalidating only the
            // narrow one would leave the dialog offering yesterday's templates.
            queryClient.invalidateQueries(formConfigTemplatesQueryKey(input.recordType));
            queryClient.invalidateQueries(formConfigTemplatesQueryKey());
            moduleSettingInvalidationKeys(created.settingKey)
                .forEach(function (queryKey) { return queryClient.invalidateQueries(queryKey); });
        },
    });
    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isLoading: mutation.isLoading,
        isError: mutation.isError,
        errorStatus: (_b = (_a = mutation.error) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : null,
        timedOut: (_d = (_c = mutation.error) === null || _c === void 0 ? void 0 : _c.timedOut) !== null && _d !== void 0 ? _d : false,
        errorBody: (_f = (_e = mutation.error) === null || _e === void 0 ? void 0 : _e.body) !== null && _f !== void 0 ? _f : null,
        reset: mutation.reset,
    };
};
export default useCreateFormConfig;
